/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { InvolvementProfileConfig } from "../model"
// @ts-ignore
import type { InvolvementQuestion } from "../model"
// @ts-ignore
import type { QuestionInvolvementSaveRequest } from "../model"
/**
 * InvolvementCheckResourceApi - axios parameter creator
 */
export const InvolvementCheckResourceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get question categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/involvement_check/categories`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update involvement profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfiles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/involvement_check/profiles`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get questions by note id filtered by category
     * @param {string} [noteId]
     * @param {GetQuestionCategoryEnum} [category]
     * @param {boolean} [forceV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestion: async (
      noteId?: string,
      category?: GetQuestionCategoryEnum,
      forceV2?: boolean,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/involvement_check/questions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (noteId !== undefined) {
        localVarQueryParameter["noteId"] = noteId
      }

      if (category !== undefined) {
        localVarQueryParameter["category"] = category
      }

      if (forceV2 !== undefined) {
        localVarQueryParameter["forceV2"] = forceV2
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Create a question
     * @param {QuestionInvolvementSaveRequest} questionInvolvementSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertQuestion: async (
      questionInvolvementSaveRequest: QuestionInvolvementSaveRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'questionInvolvementSaveRequest' is not null or undefined
      assertParamExists(
        "insertQuestion",
        "questionInvolvementSaveRequest",
        questionInvolvementSaveRequest
      )
      const localVarPath = `/involvement_check/questions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        questionInvolvementSaveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update a profile\'s configuration
     * @param {SetProfileConfigProfileEnum} profile
     * @param {string} label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setProfileConfig: async (
      profile: SetProfileConfigProfileEnum,
      label: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'profile' is not null or undefined
      assertParamExists("setProfileConfig", "profile", profile)
      // verify required parameter 'label' is not null or undefined
      assertParamExists("setProfileConfig", "label", label)
      const localVarPath = `/involvement_check/profiles`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (profile !== undefined) {
        localVarQueryParameter["profile"] = profile
      }

      if (label !== undefined) {
        localVarQueryParameter["label"] = label
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update a question
     * @param {number} questionId
     * @param {QuestionInvolvementSaveRequest} questionInvolvementSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuestion: async (
      questionId: number,
      questionInvolvementSaveRequest: QuestionInvolvementSaveRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'questionId' is not null or undefined
      assertParamExists("updateQuestion", "questionId", questionId)
      // verify required parameter 'questionInvolvementSaveRequest' is not null or undefined
      assertParamExists(
        "updateQuestion",
        "questionInvolvementSaveRequest",
        questionInvolvementSaveRequest
      )
      const localVarPath = `/involvement_check/questions/{questionId}`.replace(
        "{questionId}",
        encodeURIComponent(String(questionId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        questionInvolvementSaveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update multiple questions
     * @param {{ [key: string]: QuestionInvolvementSaveRequest; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuestions: async (
      requestBody: { [key: string]: QuestionInvolvementSaveRequest },
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'requestBody' is not null or undefined
      assertParamExists("updateQuestions", "requestBody", requestBody)
      const localVarPath = `/involvement_check/questions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * InvolvementCheckResourceApi - functional programming interface
 */
export const InvolvementCheckResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InvolvementCheckResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get question categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCategories(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvolvementCheckResourceApi.getCategories"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update involvement profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProfiles(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvolvementProfileConfig>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProfiles(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvolvementCheckResourceApi.getProfiles"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get questions by note id filtered by category
     * @param {string} [noteId]
     * @param {GetQuestionCategoryEnum} [category]
     * @param {boolean} [forceV2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getQuestion(
      noteId?: string,
      category?: GetQuestionCategoryEnum,
      forceV2?: boolean,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvolvementQuestion>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestion(
        noteId,
        category,
        forceV2,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvolvementCheckResourceApi.getQuestion"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a question
     * @param {QuestionInvolvementSaveRequest} questionInvolvementSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async insertQuestion(
      questionInvolvementSaveRequest: QuestionInvolvementSaveRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvolvementQuestion>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.insertQuestion(
        questionInvolvementSaveRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvolvementCheckResourceApi.insertQuestion"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a profile\'s configuration
     * @param {SetProfileConfigProfileEnum} profile
     * @param {string} label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setProfileConfig(
      profile: SetProfileConfigProfileEnum,
      label: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvolvementProfileConfig>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.setProfileConfig(
        profile,
        label,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvolvementCheckResourceApi.setProfileConfig"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a question
     * @param {number} questionId
     * @param {QuestionInvolvementSaveRequest} questionInvolvementSaveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateQuestion(
      questionId: number,
      questionInvolvementSaveRequest: QuestionInvolvementSaveRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvolvementQuestion>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestion(
        questionId,
        questionInvolvementSaveRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvolvementCheckResourceApi.updateQuestion"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update multiple questions
     * @param {{ [key: string]: QuestionInvolvementSaveRequest; }} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateQuestions(
      requestBody: { [key: string]: QuestionInvolvementSaveRequest },
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvolvementQuestion>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestions(
        requestBody,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["InvolvementCheckResourceApi.updateQuestions"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * InvolvementCheckResourceApi - factory interface
 */
export const InvolvementCheckResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InvolvementCheckResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get question categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
      return localVarFp.getCategories(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update involvement profiles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfiles(options?: RawAxiosRequestConfig): AxiosPromise<Array<InvolvementProfileConfig>> {
      return localVarFp.getProfiles(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get questions by note id filtered by category
     * @param {InvolvementCheckResourceApiGetQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuestion(
      requestParameters: InvolvementCheckResourceApiGetQuestionRequest = {},
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InvolvementQuestion>> {
      return localVarFp
        .getQuestion(
          requestParameters.noteId,
          requestParameters.category,
          requestParameters.forceV2,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Create a question
     * @param {InvolvementCheckResourceApiInsertQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insertQuestion(
      requestParameters: InvolvementCheckResourceApiInsertQuestionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InvolvementQuestion> {
      return localVarFp
        .insertQuestion(requestParameters.questionInvolvementSaveRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update a profile\'s configuration
     * @param {InvolvementCheckResourceApiSetProfileConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setProfileConfig(
      requestParameters: InvolvementCheckResourceApiSetProfileConfigRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InvolvementProfileConfig> {
      return localVarFp
        .setProfileConfig(requestParameters.profile, requestParameters.label, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update a question
     * @param {InvolvementCheckResourceApiUpdateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuestion(
      requestParameters: InvolvementCheckResourceApiUpdateQuestionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<InvolvementQuestion> {
      return localVarFp
        .updateQuestion(
          requestParameters.questionId,
          requestParameters.questionInvolvementSaveRequest,
          options
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update multiple questions
     * @param {InvolvementCheckResourceApiUpdateQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateQuestions(
      requestParameters: InvolvementCheckResourceApiUpdateQuestionsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<InvolvementQuestion>> {
      return localVarFp
        .updateQuestions(requestParameters.requestBody, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getQuestion operation in InvolvementCheckResourceApi.
 */
export interface InvolvementCheckResourceApiGetQuestionRequest {
  readonly noteId?: string

  readonly category?: GetQuestionCategoryEnum

  readonly forceV2?: boolean
}

/**
 * Request parameters for insertQuestion operation in InvolvementCheckResourceApi.
 */
export interface InvolvementCheckResourceApiInsertQuestionRequest {
  readonly questionInvolvementSaveRequest: QuestionInvolvementSaveRequest
}

/**
 * Request parameters for setProfileConfig operation in InvolvementCheckResourceApi.
 */
export interface InvolvementCheckResourceApiSetProfileConfigRequest {
  readonly profile: SetProfileConfigProfileEnum

  readonly label: string
}

/**
 * Request parameters for updateQuestion operation in InvolvementCheckResourceApi.
 */
export interface InvolvementCheckResourceApiUpdateQuestionRequest {
  readonly questionId: number

  readonly questionInvolvementSaveRequest: QuestionInvolvementSaveRequest
}

/**
 * Request parameters for updateQuestions operation in InvolvementCheckResourceApi.
 */
export interface InvolvementCheckResourceApiUpdateQuestionsRequest {
  readonly requestBody: { [key: string]: QuestionInvolvementSaveRequest }
}

/**
 * InvolvementCheckResourceApi - object-oriented interface
 */
export class InvolvementCheckResourceApi extends BaseAPI {
  /**
   *
   * @summary Get question categories
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getCategories(options?: RawAxiosRequestConfig) {
    return InvolvementCheckResourceApiFp(this.configuration)
      .getCategories(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update involvement profiles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getProfiles(options?: RawAxiosRequestConfig) {
    return InvolvementCheckResourceApiFp(this.configuration)
      .getProfiles(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get questions by note id filtered by category
   * @param {InvolvementCheckResourceApiGetQuestionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getQuestion(
    requestParameters: InvolvementCheckResourceApiGetQuestionRequest = {},
    options?: RawAxiosRequestConfig
  ) {
    return InvolvementCheckResourceApiFp(this.configuration)
      .getQuestion(
        requestParameters.noteId,
        requestParameters.category,
        requestParameters.forceV2,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a question
   * @param {InvolvementCheckResourceApiInsertQuestionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public insertQuestion(
    requestParameters: InvolvementCheckResourceApiInsertQuestionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InvolvementCheckResourceApiFp(this.configuration)
      .insertQuestion(requestParameters.questionInvolvementSaveRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a profile\'s configuration
   * @param {InvolvementCheckResourceApiSetProfileConfigRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public setProfileConfig(
    requestParameters: InvolvementCheckResourceApiSetProfileConfigRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InvolvementCheckResourceApiFp(this.configuration)
      .setProfileConfig(requestParameters.profile, requestParameters.label, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a question
   * @param {InvolvementCheckResourceApiUpdateQuestionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateQuestion(
    requestParameters: InvolvementCheckResourceApiUpdateQuestionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InvolvementCheckResourceApiFp(this.configuration)
      .updateQuestion(
        requestParameters.questionId,
        requestParameters.questionInvolvementSaveRequest,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update multiple questions
   * @param {InvolvementCheckResourceApiUpdateQuestionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateQuestions(
    requestParameters: InvolvementCheckResourceApiUpdateQuestionsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return InvolvementCheckResourceApiFp(this.configuration)
      .updateQuestions(requestParameters.requestBody, options)
      .then(request => request(this.axios, this.basePath))
  }
}

export const GetQuestionCategoryEnum = {
  EMPLOYMENT: "EMPLOYMENT",
  TERRITORY: "TERRITORY",
  SOCIAL: "SOCIAL",
  ENVIRONMENT: "ENVIRONMENT",
  GOVERNANCE: "GOVERNANCE",
  OTHER: "OTHER"
} as const
export type GetQuestionCategoryEnum =
  (typeof GetQuestionCategoryEnum)[keyof typeof GetQuestionCategoryEnum]
export const SetProfileConfigProfileEnum = {
  NO_INVOLVEMENT: "NO_INVOLVEMENT",
  EMPLOYER: "EMPLOYER",
  TERRITORIAL: "TERRITORIAL",
  SOCIAL: "SOCIAL",
  ECOLO: "ECOLO",
  ETHICS: "ETHICS",
  OTHER: "OTHER",
  MULTI_COMMITTED: "MULTI_COMMITTED"
} as const
export type SetProfileConfigProfileEnum =
  (typeof SetProfileConfigProfileEnum)[keyof typeof SetProfileConfigProfileEnum]
